import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'main',
    loadComponent: () =>
      import('./pages/main-page/main-page.component').then(
        (p) => p.MainPageComponent,
      ),
  },
];
